import React, {useContext} from 'react'
import { Row, Col, Select, Input  } from "antd";
import { FilterFilled, CloseSquareFilled, BarChartOutlined  } from '@ant-design/icons';
import { locations } from '../../util/details';
import { AppContext } from '../../util/context';
import "../../pages/Home/Home.css";

const {Search} = Input;
const {Option} = Select;

export const FilterView = ({
    modalDetails,
    setModalDetails,
    filterDetails,
    handleFilterChange,
    handleClearAllFilters,
    current
}) => {
    const {
        StyledDiv
    } = useContext(AppContext)
    return (
        <Row
            style={{
                height: "10%",
            }}
        >

            <Col
                xl={{span: 10}}
                lg={{span: 18}}
                md={{span: 18}}
                sm={{span: 18}}
                xs={{span: 18}}
                style={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                }}
            >
                <Search
                    placeholder={
                        (current === "mycards" || current === "allcards" || current === "myteamscards") ? "Search Cards" :
                        (current === "myactions" || current === "allactions" || current === "assignedactions") ? "Search Actions" :
                        ""
                    }
                    allowClear
                    className="inputText"
                    value={filterDetails.search}
                    onChange={(e) => handleFilterChange("search", e.target.value)}
                />
            </Col>

            <Col
                xl={{span: 14}}
                lg={{span: 6}}
                md={{span: 6}}
                sm={{span: 6}}
                xs={{span: 6}}
                
            >
                <Row
                    className="filterContainer"
                >
                    <Col
                        xl={{span: 10}}
                        lg={{span: 10}}
                        md={{span: 0}}
                        sm={{span: 0}}
                        xs={{span: 0}}
                        className="filterColumn"
                    >
                        <StyledDiv
                            style={{
                                width: "100%",
                            }}
                        >
                            <Select style={{width: "90%", height: "30px", fontSize: "12px"}}
                                showSearch
                                placeholder="Location"
                                size='small'
                                onChange={(value) => handleFilterChange("location", value)}
                                value={filterDetails.location}
                            >   
                                <Option value='none' className="inputText" style={{fontSize: "12px"}}> </Option>
                                {locations.map((location, index) => (
                                    <Option key={index} value={location.value} className="inputText" style={{fontSize: "12px"}}>{location.name}</Option>
                                ))}
                            </Select>
                        </StyledDiv>
                    </Col>

                    <Col
                        xl={{span: 10}}
                        lg={{span: 10}}
                        md={{span: 0}}
                        sm={{span: 0}}
                        xs={{span: 0}}
                        className="filterColumn"
                    >
                        <StyledDiv
                            style={{
                                width: "100%"
                            }}
                        >
                            <Select style={{width: "90%", height: "30px", fontSize: "12px"}}
                                placeholder="status"
                                size='small'
                                onChange={(value) => handleFilterChange("status", value)}
                                value={filterDetails.status}
                            >   
                                <Option value='none' className="inputText" style={{fontSize: "12px"}}> </Option>
                                <Option value='open' className="inputText" style={{fontSize: "12px"}}>Open</Option>
                                <Option value='assigned' className="inputText" style={{fontSize: "12px"}}>Assigned</Option>
                                {(current === 'allactions' || current === 'myactions') && <Option value='reassigned' className="inputText" style={{fontSize: "12px"}}>Reassigned</Option>}
                                {(current === 'allactions' || current === 'myactions' || current === 'assignedactions') && <Option value='completed' className="inputText" style={{fontSize: "12px"}}>Completed</Option>}
                                <Option value='closed' className="inputText" style={{fontSize: "12px"}}>Closed</Option>
                                <Option value='void' className="inputText" style={{fontSize: "12px"}}>Void</Option>
                                
                            </Select>
                        </StyledDiv>
                    </Col>

                    <Col
                        xl={{span: 4}}
                        lg={{span: 24}}
                        md={{span: 24}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        
                    >
                        <Row
                            className="firstFilterContainer"
                        >
                            <Col
                                span={12}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'start',
                                    paddingLeft: "5px"
                                }}
                            >
                                <FilterFilled 
                                    className="filterIcon"
                                    onClick = {() => setModalDetails({show: true, insights: false})}
                                />
                            </Col>

                            <Col
                                span={12}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    paddingRight: "10px"
                                }}
                            >
                                <CloseSquareFilled 
                                    className="filterIcon"
                                    onClick = {handleClearAllFilters}
                                />
                            </Col>
                        </Row>

                        <Row
                            className="InsightsModalContainer"
                        >
                            <Col span={12}></Col>

                            <Col
                                span={12}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    paddingRight: "10px",
                                    paddingTop: "20px",
                                }}
                            >
                                <BarChartOutlined 
                                    className="filterIcon"
                                    onClick = {() => setModalDetails({show: true, insights: true})}
                                />
                            </Col>

                            
                        </Row>

                    </Col>
                    
                </Row>
            </Col>
        </Row>
    )
}
